import { ICodiceLavorazionePostel, IField } from '../../shared/interfaces'

export interface PrintAndSendWizardReduxState {
    mittentePrintAndSendFields?: IField[],
    destinatarioPrintAndSendFields?: IField[],
    sendTypePrintAndSendFields?: IField[],
    codiciLavorazione?: ICodiceLavorazionePostel[],
    valid?: boolean,
    touched?: boolean,
    stepIndex: number,
    activeAccordionIndex: number,

}

export const RESET_PRINT_AND_SEND_FIELDS = 'RESET_PRINT_AND_SEND_FIELDS'
interface ResetPrintAndSendFields {
    type: typeof RESET_PRINT_AND_SEND_FIELDS
}

export const UPDATE_PRINT_AND_SEND_WIZARD_STATE = 'UPDATE_PRINT_AND_SEND_WIZARD_STATE'
interface UpdatePrintAndSendWizardState {
    type: typeof UPDATE_PRINT_AND_SEND_WIZARD_STATE
    payload: Partial<PrintAndSendWizardReduxState>
}

export const SET_STEP_INDEX = 'SET_STEP_INDEX'
interface SetStepIndexAction {
    type: typeof SET_STEP_INDEX
    stepIndex: number
}

export const NEXT_STEP_INDEX = 'NEXT_STEP_INDEX'
interface NextStepIndexAction {
    type: typeof NEXT_STEP_INDEX
}

export const PREVIOUS_STEP_INDEX = 'PREVIOUS_STEP_INDEX'
interface PreviousStepIndexAction {
    type: typeof PREVIOUS_STEP_INDEX
}


export const SET_ACTIVE_ACCORDION_INDEX = 'SET_ACTIVE_ACCORDION_INDEX'
interface SetActiveAccordionIndexAction {
    type: typeof SET_ACTIVE_ACCORDION_INDEX
    activeAccordionIndex: number
}


export type PrintAndSendWizardActionTypes = ResetPrintAndSendFields | UpdatePrintAndSendWizardState | SetStepIndexAction | NextStepIndexAction | PreviousStepIndexAction | SetActiveAccordionIndexAction